import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';
import {
  publishStripeMXPublicKey,
  publishStripePublicKey,
} from 'Jsx/CheckoutV4/shared/hooks/useStripeV2Lib/publishStripePublicKey';
import { StripeTokenResponse } from 'Jsx/CheckoutV4/types/StripeV2';

import { CreditCardState } from '../../../../UserInputFields/CreditCardInput/CreditCardInput';

export const StripeErrorCode: { [id: string]: string } = {
  incorrect_cvc: I18N_STRINGS.INVALID_CVC_CVV,
  invalid_number: I18N_STRINGS.INVALID_CARD_NUMBER,
  incorrect_number: I18N_STRINGS.INCORRECT_CARD_NUMBER,
  expired_card: I18N_STRINGS.EXPIRED_CARD,
  card_declined: I18N_STRINGS.CARD_DECLINED,
  processing_error: I18N_STRINGS.CATCH_MESSAGE,
  invalid_expiry_year: I18N_STRINGS.INVALID_EXPIRATION_DATE,
  approve_with_id: I18N_STRINGS.INSUFFICIENT_FUNDS,
  withdrawal_count_limit_exceeded: I18N_STRINGS.INSUFFICIENT_FUNDS,
};

export class StripeError extends Error {
  public code: string;

  constructor(code: string) {
    super();
    this.code = code;
    this.message = StripeErrorCode[code] || I18N_STRINGS.CATCH_MESSAGE;
  }
}

const stripeResponseHandler = ({
  res,
}: {
  status: number;
  res: StripeTokenResponse;
}) => {
  if (res.error) {
    return { token: '', error: new StripeError(res.error.code).message };
  }
  return { token: res.id };
};

export function getStripeToken({ number, expiration, cvc }: CreditCardState) {
  return new Promise<{ token: string; error?: string }>((resolve, _) => {
    publishStripePublicKey(window.Stripe);

    window.Stripe.card.createToken(
      {
        number,
        exp: expiration,
        cvc,
      },
      (status, res) => resolve(stripeResponseHandler({ status, res })),
    );
  });
}

export function getStripeMexicoToken({
  number,
  expiration,
  cvc,
}: CreditCardState) {
  return new Promise<{ token: string; error?: string }>((resolve, _) => {
    publishStripeMXPublicKey(window.Stripe);

    window.Stripe.card.createToken(
      {
        number,
        exp: expiration,
        cvc,
      },
      (status, res) => resolve(stripeResponseHandler({ status, res })),
    );
  });
}
